import { documentReady } from './utils';
import $ from "jquery";

//TODO: investigate and check this stuff

const InputFile = {
    initialize: () => {

        documentReady(() => {
            InputFile.initInputFile();
            InputFile.clearInputFile();
        });
    },
    initInputFile: function () {
        $('body').on('change', '.js-inputfile', function (e) {
            var fileName = '';
            var $label   = $(e.currentTarget).next('label'),
                labelVal = $label.html(),
                $formItem = $label.closest('.inputfile');

            if (this.files && this.files.length > 1) {
                fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
            } else {
                //fileName = e.target.value.split("\"").pop();
                fileName = e.target.files[0].name;
            }

            if (fileName) {
                $label.find('.inputfile__result').text(fileName);
                $formItem.find('.inputfile__delete').show();
            } else {
                $label.text(labelVal);
            }
        });
    },
    clearInputFile : function () {
        $('body').on('click', '.js-delete-inputfile', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var $obj = $(e.currentTarget);
            $obj.closest('label').prev('[type="file"]').val('');
            $obj.closest('label').find('.inputfile__result').text('');
            $obj.hide();
        });
    }

}

InputFile.initialize();

export default InputFile;
